import {LitElement, html, unsafeCSS} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {ImgInterface} from "../../../library/images.ts";
import headerCss from './bt-header.scss?inline';
import {queryAssignedElements} from 'lit/decorators/query-assigned-elements.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import '@shoelace-style/shoelace/dist/components/divider/divider.js';
import {applyGlobalStyles} from "../../../library/runOnce.ts";

export interface BtHeaderInterface {
    image: ImgInterface
}

let isHeaderExists = false;

@customElement('bt-header')
export class BtHeader extends LitElement {


    constructor(args: BtHeaderInterface) {
        super();
        isHeaderExists = applyGlobalStyles(headerCss, isHeaderExists)

        if (!args) {
            return
        }
        this.image = args.image;
    }

    @property()
    docsHint = '';

    @property({type: Object})
    image: ImgInterface = {
        src: "https://localhost:44308/media/pzlj0zc2/trust_logo_tcm106-68717.png",
        alt: "Image alt text",
        mediumSrc: "https://localhost:44308/media/pzlj0zc2/trust_logo_tcm106-68717.png",
        largeSrc: "https://localhost:44308/media/pzlj0zc2/trust_logo_tcm106-68717.png",
        xLargeSrc: "https://localhost:44308/media/pzlj0zc2/trust_logo_tcm106-68717.png",
        lazy: "false",
    }

    @queryAssignedElements({slot: 'mainNavigationLinks'})
    mainNavigationMenuItems!:  Array<HTMLElement>;
    @property({type: Array}) mainNavigation: Element[] = [];
    @queryAssignedElements({slot: 'subnavigationLinks'})
    subnavigationMenuItems!: Array<HTMLElement>;
    @property({type: Array}) subnavigation: Element[] = [];
    @queryAssignedElements({slot: 'parentLink'})
    parentLinkItems!: Array<HTMLElement>;
    @property({type: Array}) parentLink: Element[] = [];
    @queryAssignedElements({slot: 'socialMediaIcons'})
    socialMediaIcons!: Array<HTMLElement>;
    @property({type: Array}) socialMediaIcon: Element[] = [];

    render() {
        return html`
            <header>
                <div class="bt-header-main-navigation bg-full-bleed">
                    <div class="bt-header-main-navigation-grid">
                        <slot name="parentLink"></slot>
                        <div class="bt-header-main-navigation-links">
                            <slot name="mainNavigationLinks"></slot>
                            ${this.mainNavigation?.map((el: Element) =>
                                    html`${el.classList.remove("hidden")}`
                            )}
                        </div>
                        <slot name="socialMediaIcons" class="bt-header-main-navigation-icon-group">
                        </slot>
                    </div>
                </div>
                <div class="bt-header-subnavigation bg-full-bleed">
                    <div class="bt-header-subnavigation-grid">
                        <div class="bt-header-subnavigation-logo">
                            <a href="/" class="bt-header-subnavigation-logo-link" area-label="Benefact Trust">
                                <slot name="header-logo"></slot>
                            </a>
                        </div>
                        ${this.mainNavigation?.map((el: Element) =>
                                html`${el.classList.remove("hidden")}`
                        )}
                        <slot name="subnavigationLinks"></slot>
                        ${this.subnavigationMenuItems}
                        <div class="bt-header-subnavigation-mobile">
                            <sl-button class="bt-header-subnavigation-menu-button bt-menu-button" variant="default"
                                       size="small">
                            <sl-icon label="menu" slot="suffix" src="/ui/svg/menu-burger-horizontal.svg"></sl-icon>
                                MENU
                            </sl-button>
                        </div>
                    </div>
                </div>
                <div class="bt-header-search bg-full-bleed" id="header-search">
                    <form class="bt-header-search-grid" method="get" action="/search" id="search-form">
                        <div class="bt-header-search-input">
                            <sl-input id="bt-header-search-input-field" label="Search" name="q"
                                      placeholder="Enter search" size="large"
                                      style="--sl-input-border-width: 0px;"></sl-input>
                        </div>
                        <div class="bt-header-search-button">
                            <sl-button id="bt-header-search-button-submit-btn" class="bt-header-search-button-submit"
                                       size="large" type="submit">SUBMIT
                            </sl-button>
                        </div>
                    </form>
                </div>
                <div class="bt-header-mobile-menu bg-full-bleed" id="header-mobile-menu">
                    <div class="bt-header-mobile-menu-search">
                        <form method="get" action="/search" id="search-form">
                            <div class="bt-header-search-input">
                                <sl-input name="q"
                                          placeholder="Enter search" size="small"
                                          style="--sl-input-border-width: 0px;"></sl-input>
                                <sl-button id="bt-header-search-button-submit-btn"
                                           class="bt-header-search-button-submit"
                                           size="small" type="submit">SUBMIT
                                </sl-button>
                            </div>
                        </form>
                    </div>
                    <div class="bt-header-mobile-menu-subnavigation-links">
                        ${this.subnavigation?.map((el) => html`
                            <a aria-label="${el.ariaLabel}" href="${el.getAttribute("href")}">
                                ${el.textContent}
                            </a>`
                        )}
                    </div>
                    <sl-divider style="--color: #fff; margin-left: 30px; margin-right: 30px;"></sl-divider>
                    <div class="bt-header-mobile-menu-navigation-links">

                        ${this.mainNavigation?.map((el) => html`
                            <a aria-label="${el.ariaLabel}" href="${el.getAttribute("href")}">
                                ${el.textContent}
                            </a>`
                        )}
                    </div>
                </div>
            </header>

        `
    }

    static styles = unsafeCSS(headerCss)


    firstUpdated = () => {
        this.waitForSlots();

        // Toggle mobile menu
        let menuButton = this.shadowRoot?.querySelectorAll(".bt-menu-button");
        let menu = this.shadowRoot?.getElementById("header-mobile-menu");
        if (!menuButton) {
            return;
        }
        for (let i = 0; i < menuButton.length; i++) {
            menuButton[i].addEventListener("click", function () {
                menu?.classList.toggle("bt-header-show");
            })
        }
       


    }

    updateLinkItems() {

        if (this.mainNavigationMenuItems) {
            this.mainNavigation = Array.from(this.mainNavigationMenuItems);
        }

        if (this.subnavigationMenuItems && this.subnavigationMenuItems.length > 0) {
            this.subnavigation = Array.from(this.subnavigationMenuItems[0].children);
        }

        if (this.parentLinkItems) {
            this.parentLink = Array.from(this.parentLinkItems);
        }
        if (this.socialMediaIcons) {
            // Toggle search container
            let searchButton = document.getElementById("search-button");


            if (!searchButton) {
                return;
            }

            searchButton.addEventListener("click", () => this.toggleHeaderSearch(searchButton));

        }
        this.requestUpdate();
    }

    toggleHeaderSearch(searchButton: HTMLElement) {

        let search = this.shadowRoot?.getElementById("header-search");

        if (searchButton.getAttribute("aria-expanded") == "true") {
            searchButton.setAttribute("aria-expanded", "false")
            searchButton.setAttribute("aria-label", "Show Search text entry panel")

        } else {
            searchButton.setAttribute("aria-expanded", "true")
            searchButton.setAttribute("aria-label", "Hide Search text entry panel")

        }
        if (search?.classList.toggle("bt-header-show")) {
            let searchInput = this.shadowRoot?.getElementById("bt-header-search-input-field");
            let inputBox = searchInput?.shadowRoot?.getElementById("input") as HTMLInputElement;
            if (inputBox !== null) {
                setTimeout(function () {

                    if (document.activeElement !== inputBox) {
                        inputBox.focus({preventScroll: true});
                    }

                }, 1000);
            }
        }


    }

    async waitForSlots() {
        //Slots are loading after update functions run. This one is for waiting until slots are loaded.
        let retries = 5;
        while ((!this.mainNavigationMenuItems?.length || !this.subnavigationMenuItems[0].querySelectorAll('.bt-header-subnavigation-link-item').length || !this.parentLinkItems?.length || !this.socialMediaIcons?.length) && retries > 0) {
            await new Promise((resolve) => setTimeout(resolve, 100));
            retries--;
        }
        this.updateLinkItems();
    }

}

declare global {
    interface HTMLElementTagNameMap {
        'bt-header': BtHeader
    }
}

